import React from 'react';
import { useTheme, useMergeClasses } from '../../../../../theme';
import cn from 'classnames';
const QntBadge = ({ classes, count, variant = 'default', onClick }) => {
    const { QntBadge: defaultClasses } = useTheme('Shared');
    const css = useMergeClasses(defaultClasses, classes);
    return (React.createElement("span", { className: cn(css.badge, {
            [css.invert]: variant === 'invert',
            [css.clickable]: onClick
        }), onClick: onClick },
        React.createElement("span", { className: css.badge__count }, count)));
};
export default QntBadge;
